module.exports = __webpack_public_path__ + "assets/apply2.d35abb16.svg";